import React from 'react'

import { Facebook, Twitter,Email,Reddit,Tumblr } from 'react-sharingbuttons'
import 'react-sharingbuttons/dist/main.css'



function Share() {
    const url = 'https://github.com/caspg/react-sharingbuttons'
    const shareText = 'Check this site!'

    const btnStyle ={
        display: 'inline-flex',
    }
    return (
        <div className="Share-page">
            <h1 className="Share-page-heading">Sharing is caring</h1>
            <br />
            <h1></h1>
            <div className="Share-continer">

            <Facebook style={btnStyle} className="btn btn-share"  url={url} text={shareText} />
            <Twitter style={btnStyle} url={url} shareText={shareText} />
            <Email style={btnStyle} url={url} shareText={shareText} />
            <Reddit style={btnStyle} url={url} shareText={shareText} />
            <Tumblr style={btnStyle} url={url} shareText={shareText} />
            </div>
        </div>
    )
}

export default Share
